import { createApi } from 'ext/lib/api';
import { login, isSpoofing } from 'ext/lib/auth/web';
import { REGION_TO_AWS } from 'ext/lib/auth/constants';

export default async function initializeLegacy() {
  const auth = await login();
  const spoofing = await isSpoofing();

  const api = await createApi({
    jwt: auth.jwt,
    accountId: auth.accountId,
    standalone: true,
  });

  const user = await api.getUser(auth.userId);
  const account = await api.getAccount();

  return {
    auth: {
      ...auth,
      accountId: auth.accountId,
      userId: auth.userId,
    },
    user: { ...user, isSpoofing: spoofing },
    account,
    studioUrl: import.meta.env.STUDIO_URL,
    region: REGION_TO_AWS.US, // Legacy is always US region
  };
}
